import Widget from 'models/dashboard/widget'

Widget.AgentAdValueWidget = Widget.extend({
  agentIds: function () {
    return this.get('agent_ids');
  }
});

export default Widget.AgentAdValueWidget;

